
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_nulx3_3",
  "top-navigation": "awsui_top-navigation_4c84z_nulx3_48",
  "weight-bold": "awsui_weight-bold_4c84z_nulx3_63",
  "weight-normal": "awsui_weight-normal_4c84z_nulx3_67",
  "color-inverted": "awsui_color-inverted_4c84z_nulx3_71",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_nulx3_79",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_nulx3_84",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_nulx3_88",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_nulx3_92",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_nulx3_97",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_nulx3_102",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_nulx3_107",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_nulx3_112",
  "icon": "awsui_icon_4c84z_nulx3_118"
};
  